import { render, staticRenderFns } from "./SearchImageCarousel.vue?vue&type=template&id=b5897494&"
import script from "./SearchImageCarousel.vue?vue&type=script&lang=js&"
export * from "./SearchImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5897494')) {
      api.createRecord('b5897494', component.options)
    } else {
      api.reload('b5897494', component.options)
    }
    module.hot.accept("./SearchImageCarousel.vue?vue&type=template&id=b5897494&", function () {
      api.rerender('b5897494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BkvWVVpGtkJX/JS/comp/SearchImageCarousel.vue"
export default component.exports